var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraggableLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 4.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 8.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 12.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    y: 16.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    y: 20.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 20.5,
    width: 2,
    height: 2,
    fill: "#CFCCD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggableLight);
export default __webpack_public_path__ + "static/media/draggable-light.b4757894134dd38070a600c7cd964f27.svg";
export { ForwardRef as ReactComponent };